module.exports = __webpack_public_path__ + "media/images/countrysquared/ar-cd623b24e4cb2a0a8054e56c5c28a242.svg";